import FeatureCard from "./FeatureCard";
import { Mail, FileText, Folder, PaperclipIcon, Home, Users, Briefcase, Phone, Menu, X, Code, Rocket, Settings } from 'lucide-react';

// About Page
const AboutPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-amber-50 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">About Techapplics</h1>
            <p className="text-xl text-gray-600">
              Your trusted partner in tech recruitment and software development.
            </p>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Our Story</h2>
            <div className="bg-white p-8 rounded-lg shadow-md space-y-6">
              <p className="text-gray-600">
                <strong>Techapplics</strong> is a new-age startup built with a bold vision: to solve two of the most critical challenges in the tech industry today — hiring the right talent and building the right technology.
                In today’s fast-moving digital world, many startups and growing companies struggle to scale their teams and deliver high-quality software at the same time. Techapplics was born from the belief that businesses shouldn't have to choose between building great products and building great teams — they deserve a partner who can help with both.
              </p>

              <p className="text-gray-600">
                Today, we pride ourselves on our dual expertise in both human capital and technological solutions. Our team of experienced recruiters and skilled developers work hand in hand to deliver holistic solutions that drive business success.
              </p>

              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">🎯 Our Mission</h3>
                <p className="text-gray-600">
                  To empower companies with top-tier tech talent and modern software solutions — so they can grow faster, smarter, and with greater confidence.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">💡 What We Do</h3>
                <ul className="list-disc list-inside text-gray-600 space-y-2">
                  <li>
                    <strong>Tech Recruitment & Job Consultancy:</strong> We connect startups and tech companies with skilled developers, designers, and IT professionals. Our consultancy approach helps job seekers find the right roles and companies build teams that last.
                  </li>
                  <li>
                    <strong>Custom Software Development:</strong> From MVPs for startups to scalable enterprise tools, our developers build clean, reliable, and future-ready applications. We bring deep technical expertise across modern stacks, agile practices, and product thinking.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Team */}
      {/* <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Our Leadership Team</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="bg-amber-100 h-48 flex items-center justify-center">
                <Users size={64} className="text-gray-800 opacity-50" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-1">Jennifer Lee</h3>
                <p className="text-amber-600 mb-4">CEO & Founder</p>
                <p className="text-gray-600">
                  With over 15 years in tech recruitment, Jennifer brings her expertise and vision to lead our company.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="bg-amber-100 h-48 flex items-center justify-center">
                <Users size={64} className="text-gray-800 opacity-50" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-1">David Rodriguez</h3>
                <p className="text-amber-600 mb-4">CTO</p>
                <p className="text-gray-600">
                  David leads our software development team, bringing 12 years of experience in building enterprise solutions.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="bg-amber-100 h-48 flex items-center justify-center">
                <Users size={64} className="text-gray-800 opacity-50" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-1">Michelle Park</h3>
                <p className="text-amber-600 mb-4">Head of Recruitment</p>
                <p className="text-gray-600">
                  Michelle's network and insight into the tech talent market makes her an invaluable asset to our team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* How We Work */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">How We Work</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">1. Understand</h3>
              <p className="text-gray-600">
                We start by deeply understanding your hiring needs or product vision through discovery calls and workshops.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">2. Match or Build</h3>
              <p className="text-gray-600">
                Whether sourcing top tech talent or architecting a solution, we align resources that fit your goals and timelines.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">3. Execute</h3>
              <p className="text-gray-600">
                Our recruiters or dev teams work in sprints or hiring pipelines—providing progress updates and flexibility throughout.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">4. Support & Scale</h3>
              <p className="text-gray-600">
                We don’t stop at delivery. We stay connected for ongoing support, optimizations, or future hiring needs.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Our Values */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Our Core Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <FeatureCard
              icon={<FileText className="text-gray-800" />}
              title="Excellence"
              description="We strive for excellence in everything we do, from candidate selection to code quality."
              className="h-full"
            />
            <FeatureCard
              icon={<Users className="text-gray-800" />}
              title="Integrity"
              description="Honesty and transparency form the foundation of our relationships with clients and candidates."
              className="h-full"
            />
            <FeatureCard
              icon={<Briefcase className="text-gray-800" />}
              title="Innovation"
              description="We embrace new technologies and approaches to solve complex challenges."
              className="h-full"
            />
            <FeatureCard
              icon={<Mail className="text-gray-800" />}
              title="Partnership"
              description="We view ourselves as partners in our clients' success, not just service providers."
              className="h-full"
            />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {/* <section className="bg-amber-50 py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Join Our Growing Team</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            We're always looking for talented individuals to join our team. Check out our current openings.
          </p>
          <button className="bg-gray-800 text-white px-8 py-3 rounded-md font-medium hover:bg-gray-700 transition-colors">
            View Careers
          </button>
        </div>
      </section> */}
    </div>
  );
};

export default AboutPage